import React from 'react'

function Modal({icon, message, onSubmit, buttonText, appId}) {
  return (
        <div className="modal-backdrop">
          <div className="modal-content">
            <div className="modal-check">
            <img src={icon} alt="icon"/>
            </div>
            <p className="modal-message">
              {message}
            </p>
            {appId && (
            <p className="modal-submessage">
              Application Id: {appId}
            </p>
            )}
            <button className="modal-button" onClick={onSubmit}>
              {buttonText}
            </button>
          </div>
        </div>
  )
}

export default Modal